import React, { useState } from "react";
import { Button, TextField, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PageTransition from "../Components/PageTransition"; // <--- neu

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [transition, setTransition] = useState(null); // Pfad zum Ziel
  const navigate = useNavigate();

  const handleLogin = () => {
    if (username === "admin" && password === "admin123") {
      localStorage.setItem("role", "admin");
      setTransition("/dashboard/admin");
    } else if (username === "Vodafone" && password === "vf123") {
      localStorage.setItem("role", "vodafone");
      new Audio("/VFLogin.mp3").play();
      setTransition("/dashboard/vf-tool");
    } else if (username === "user" && password === "user123") {
      localStorage.setItem("role", "user");
      setTransition("/dashboard/user");
    } else {
      alert("Falsche Zugangsdaten.");
    }
  };

  return (
    <>
      {transition && (
        <PageTransition targetRoute={transition} logo="/vodafone-logo.png" />
      )}

      {!transition && (
        <Box sx={{ p: 4 }}>
          <Typography variant="h4" gutterBottom>
            Login
          </Typography>
          <TextField
            label="Benutzername"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="Passwort"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button variant="contained" onClick={handleLogin} sx={{ mt: 2 }}>
            Einloggen
          </Button>
        </Box>
      )}
    </>
  );
}

export default LoginPage;
